/**
 * 项目首页
 */
import React, { useEffect, useState } from 'react';
import styles from './caseCollect.module.scss';
import icon_collect_task_avatar from '../../static/images_doctor/icon_collect_task_avatar.png';
// import icon_collect_status_ing from '../../static/images_doctor/icon_collect_status_ing.png';
import icon_collect_bookmark from '../../static/images_doctor/icon_collect_bookmark.png';
import icon_collect_warning_arrow from '../../static/images_doctor/icon_collect_warning_arrow.png';
import icon_collect_warning from '../../static/images_doctor/icon_collect_warning.png';
import icon_collect_running_arrow from '../../static/images_doctor/icon_collect_running_arrow.png';
import icon_collect_running from '../../static/images_doctor/icon_collect_running.png';
import icon_collect_follow_evalution from '../../static/images_doctor/icon_collect_follow_evalution.png';
import icon_collect_quesionnaire from '../../static/images_doctor/icon_collect_quesionnaire.png';
import icon_collect_record from '../../static/images_doctor/icon_collect_record.png';
import icon_collect_ok from '../../static/images_doctor/icon_collect_ok.png';
import icon_collect_question from '../../static/images_doctor/icon_collect_wait.png';
import icon_collect_wait from '../../static/images_doctor/rwd/icon_collect_wait.png';
import icon_collect_ing from '../../static/images_doctor/icon_collect_ing.png';
import icon_collect_arrow_blue from '../../static/images_doctor/icon_collect_arrow_blue.png';
import icon_collect_arrow_orange from '../../static/images_doctor/icon_collect_arrow_orange.png';
import icon_collect_arrow_gray from '../../static/images_doctor/rwd/icon_collect_arrow_gray.png';
import icon_collect_arrow_green from '../../static/images_doctor/icon_collect_arrow_green.png';
import icon_collect_status_ing from '../../static/images_doctor/rwd/icon_collect_status_ing.png';
import icon_collect_status_completed from '../../static/images_doctor/rwd/icon_collect_status_completed.png';
import icon_collect_status_no_pass from '../../static/images_doctor/rwd/icon_collect_status_no_pass.png';
import icon_collect_status_no_sign from '../../static/images_doctor/rwd/icon_collect_status_no_sign.png';
import icon_collect_status_pass from '../../static/images_doctor/rwd/icon_collect_status_pass.png';
import icon_collect_status_audit_pass from '../../static/images_doctor/rwd/icon_collect_status_audit_pass.png';
import icon_collect_status_remain_audit from '../../static/images_doctor/rwd/icon_collect_status_remain_audit.png';
import icon_collect_status_remain_to_approve from '../../static/images_doctor/rwd/icon_collect_status_remain_to_approve.png';
import icon_collect_item_wait_gray from '../../static/images_doctor/rwd/icon_collect_item_wait_gray.png';
import warning from '../../static/images/warning.png';
import { ApiCore } from '../../api/index';
import { createFromIconfontCN } from '@ant-design/icons';
import { Dialog } from 'antd-mobile-v5';
import { Toast } from 'antd-mobile';
const api = new ApiCore();

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2323742_dm1ywqphtbf.js',
});

function CaseCollect(props: any) {

    const [subjectsData, setSubjectsData] = useState<any>({});
    const [formData, setFormData] = useState<any>([]);
    //获取审核失败原因
    const [rejectReasons, setRejectReasons] = useState<any>(props.rejectReasons || []);
    //显示签名按钮
    const [showReSubmitBtn, setShowReSubmitBtn] = useState(true);
    // 
    const [taskClicked, setTaskClicked] = useState(false);

    useEffect(() => {
        //设置网页title
        document.title = '病例征集';
    }, [])

    useEffect(() => {
        if (props.subjectsData) {
            setSubjectsData(props.subjectsData);
        }
    }, [props.subjectsData])

    useEffect(() => {
        if (props.formData) {
            setFormData(props.formData);
        }
    }, [props.formData])

    useEffect(() => {
        if (props.rejectReasons) {
            setRejectReasons(props.rejectReasons);
        }
    }, [props.rejectReasons])
    
    const stateMapText = (text: string) => {
        let _state = subjectsData.state;
        if (!_state) {
            return '';
        }
        let _text = '';
        switch (_state) {
            case 'Init':
                _text = '待入组';
                break;
            case 'Active':
                _text = '进行中';
                break;
            case 'Wait':
                if (subjectsData.auditState = 'Finish') {
                    _text = '未签署';
                } else {
                    _text = '';
                }
                break;
            case 'Finish':
                _text = '已完成';
                break;
            default:
                break;
        }
        return _text;
    }

    const checkStateMapText = (item: any) => {
        const inputState = item.inputState;
        let _text = '';
        switch (inputState) {
            case 'Complete':
                _text = '已完成';
                break;
            case 'Running':
                _text = '进行中';
                break;
            case 'Wait':
                _text = '未开始';
                break;
            case 'Question':
                _text = '待质疑处理';
                break;
            default:
                break;
        }
        return _text;
    }

    const auditStateMapText = (text: string) => {
        let _state = subjectsData.auditState;
        if (!_state) {
            return '';
        }
        let _text = '';
        switch (_state) {
            case 'Wait':
                _text = '待审核';
                break;
            case 'Pass':
                _text = '审核通过';
                break;
            case 'Fail':
                _text = '审核未通过';
                break;
            default:
                break;
        }
        return _text;
    }

    //当点击了任务按钮
    const onClickTask = (taskType: any) => {
        setTaskClicked(true);
        if (taskType === 'AuidtFail') {
            onClickAuditRejectTip();
            return;
        }
        // //保存操作访视状态
        let currentState = {
            type: 'task',
            key: taskType
        }
        sessionStorage.setItem('currentState', JSON.stringify(currentState));
        api.getVisitsByType({ subjectCode: subjectsData.code, type: taskType }).then(res => {
            if (res.code == '0') {
                setFormData(res.data)
            }
        });
    }

    //审核失败提示
    const onClickAuditRejectTip = () => {
        Dialog.alert({
            header: (
                <div></div>
            ),
            title: '',
            content: (
                <>
                    <div style={{ padding: '15px' }}>
                        <div style={{ textAlign: 'center' }}>
                            <img style={{ width: '40px' }} src={warning} alt="" />
                        </div>
                        <div style={{ color: '#ef8a00', fontWeight: 'bold', fontSize: '15px', textAlign: 'center', marginBottom: '10px' }}>
                            该任务未通过审核
                        </div>
                        <div>请您仔细检查数据填写是否有误，修改后审核人员将对您上传的任务进行重新审核</div>
                        {
                            rejectReasons && rejectReasons.length > 0 &&
                            <div style={{ color: '#000000', fontWeight: 'bold', fontSize: '14px', marginTop: '15px', marginBottom: '10px' }}>
                                未通过原因：
                            </div>
                        }
                        {
                            rejectReasons && rejectReasons.map((item: any) => (
                                <div>
                                    {item}
                                </div>
                            ))
                        }
                    </div>
                </>
            ),
        })
    }

    //审核失败质疑，重新提交
    const reSubmit = () => {
        api.toAuditResubmit(subjectsData.code).then((res: any) => {
            if (res.code == 0) {
                Toast.success('审核重新提交成功', 1);
                setShowReSubmitBtn(false);
                props.initData();
            } else {
                Toast.fail(res.message || '提交失败', 1);
            }
        })
    }

    // 签署
    const onSignLaborAgreement = () => {
        props.history.push(`/laborAgreement?code=${subjectsData.code}&signState=${subjectsData.signState}`)
    }

    /**
     * 显示操作按钮
     */

     const showAcitonBtns = () => {

        let reasons = ''
        if (rejectReasons.length > 0) {
            reasons = rejectReasons.join(',')
        }

        if (subjectsData) {
            if (subjectsData.signState == 'Wait') {
                return (
                    <div className={styles.sign_btn_wrap}>
                        <div className={styles.sign_btn} onClick={onSignLaborAgreement}>
                            未签署
                        </div>
                    </div>
                )
            } else if (subjectsData.signState == 'Pass' && reasons == '签名不合格') {
                return (
                    <div className={styles.sign_btn_wrap}>
                        <div className={styles.sign_btn} onClick={onSignLaborAgreement}>
                            <span className={styles.rest_sign}></span>
                            重新签署
                        </div>
                    </div>
                )
            }

            else if (subjectsData.auditState === "Fail" && showReSubmitBtn && !reasons.includes('签名不合格')) {
                return (
                    <div>
                        <div className={styles.btn_bottom} onClick={reSubmit}>
                            重新提交审核
                        </div>
                    </div>
                )
            }
            else {
                return (
                    <React.Fragment>
                        {
                            (subjectsData.auditState === "Fail" && showReSubmitBtn) &&
                            <div className={styles.btn_bottom} onClick={reSubmit}>重新提交审核</div>
                        }
                        {
                            subjectsData.signState == 'Pass' && reasons.includes('签名不合格') &&
                            <div className={styles.sign_btn_wrap}>
                                <div className={styles.sign_btn} onClick={onSignLaborAgreement}>
                                    <span className={styles.rest_sign}></span>
                                    {subjectsData.signState == 'Pass' ? '重新签署' : '未签署'}
                                </div>
                            </div>
                        }
                    </React.Fragment>
                )
            }
        }
    }

    const statusToImgRender = () => {
        if (subjectsData.auditState) {
            if (subjectsData.auditState === 'Wait') {
                return <img src={icon_collect_status_remain_audit} alt="" />
            } else if (subjectsData.auditState === 'Pass') {
                return <img src={icon_collect_status_audit_pass} alt="" />
            } else if (subjectsData.auditState === 'Fail') {
                return <img src={icon_collect_status_no_pass} alt="" />
            }
        } else {
            if (subjectsData.state === 'Init') {
                return <img src={icon_collect_status_remain_to_approve} alt="" />
            } else if (subjectsData.state === 'Active') {
                return <img src={icon_collect_status_ing} alt="" />
            } else if (subjectsData.state === 'Finish' && subjectsData.signState === 'Wait') {
                return <img src={icon_collect_status_no_sign} alt="" />
            } else if (subjectsData.state === 'Finish' ) {
                return <img src={icon_collect_status_completed} alt="" />
            }
        }
        return <></>;
    }

    return (
        <div className={styles.caseCollectContent}>

            <div className={styles.head}>
                <div className={styles.top}>
                    <div className={styles.left}>
                        <img src={icon_collect_task_avatar} alt="" />
                    </div>
                    <div className={styles.middle}>
                        <div className={styles.middle_top}>
                            <span className={styles.code}>
                                {subjectsData?.code}
                            </span>
                            <span className={styles.name}>
                                {subjectsData?.createUser}
                            </span>
                        </div>
                        <div className={styles.middle_bottom}>
                            {subjectsData?.projectName}
                        </div>
                    </div>
                    <div className={styles.right}>
                        {
                            statusToImgRender()
                        }
                        {/* {
                            subjectsData?.state === 'Active' && 
                        } */}
                    </div>
                </div>
            </div>
            <div className={styles.progress}>
                {
                    formData && formData.length > 0 && formData.map((item: any, index: number) => (
                                item.forms && item.forms.map((val: any, index: number) => (
                                    <div key={index} className={val.inputState === 'Complete' ? styles.complete : val.inputState === 'Running' ? styles.running : val.inputState === 'Question' ? styles.question : styles.wait}></div>
                                ))
                    ))
                }
                {/* <div className={styles.one}></div>
                <div className={styles.two}></div>
                <div className={styles.three}></div>
                <div className={styles.four}></div> */}
            </div>

            {
                subjectsData && subjectsData.tasks && (subjectsData?.tasks || []).map((val: any, index: number) => (
                    val.message ? 
                    <div key={index} className={`${styles.message} ${val.state === 'Running' ? styles.running_message: styles.warning_message} ${(taskClicked && val.state === 'Running') ? styles.running_message_active : (taskClicked) ? styles.warnning_message_active : ''}`} onClick={() => { onClickTask(val.type) }}>
                        <div className={styles.content}>
                            <img className={styles.warning} src={val.state === 'Running' ? icon_collect_running : icon_collect_warning} alt="" />
                            <span>{val.message}{val.type === 'AuidtFail' ? '请点击查看详情。' : ''}</span>
                            <img className={styles.arrow}src={val.state === 'Running' ? icon_collect_running_arrow : icon_collect_warning_arrow} alt="" />
                        </div>
                    </div>
                    :
                    null
                ))
            }

            <div className={styles.body}>
                
                <img className={styles.img_top_inlay} src={icon_collect_bookmark} alt="" />

                {
                    formData && formData.length > 0 && formData.map((item: any, index: number) => (
                                item.forms && item.forms.map((val: any, index: number) => (
                                    <div key={index} className={`${styles.outer_wrap} ${val.inputState === 'Complete' ? styles.bg_blue : val.inputState === 'Running' ? styles.bg_green: val.inputState === 'Question' ? styles.bg_orange : styles.bg_gray}`} onClick={() => { props.clickForm(item, val)() }}>
                                        <img className={`${styles.img_left_inlay} ${val.inputState === 'Complete' ? styles.blue : val.inputState === 'Running' ? styles.green: val.inputState === 'Question' ? styles.orange : styles.gray }`} src={val.inputState === 'Complete' ? icon_collect_quesionnaire : val.inputState === 'Running' ? icon_collect_record :  val.inputState === 'Question' ? icon_collect_follow_evalution : icon_collect_item_wait_gray} alt="" />
                                        <div className={styles.outer}>
                                            <div className={styles.inner}>
                                                <div className={`${styles.title} ${val.inputState === 'Complete' ? styles.blue_title : val.inputState === 'Running' ? styles.green_title: val.inputState === 'Question' ? styles.orange_title : styles.gray_title}`}>{val.name}</div>
                                                <div className={`${styles.desc} ${val.inputState === 'Complete' ? styles.blue_desc : val.inputState === 'Running' ? styles.green_desc: val.inputState === 'Question' ? styles.orange_desc : styles.gray_desc}`}>
                                                    <img src={val.inputState === 'Complete' ? icon_collect_ok : val.inputState === 'Running' ? icon_collect_ing: val.inputState === 'Question' ? icon_collect_question : icon_collect_wait} alt="" />
                                                    <span>{checkStateMapText(val)}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={styles.arrow}>
                                            <img src={val.inputState === 'Complete' ? icon_collect_arrow_blue : val.inputState === 'Running' ? icon_collect_arrow_green: val.inputState === 'Question' ? icon_collect_arrow_orange : icon_collect_arrow_gray} alt="" />
                                        </div>
                                    </div>
                                ))
                    ))
                }
                

{/* 
                <div className={`${styles.outer_wrap} ${styles.bg_orange}`}>
                    <img className={`${styles.img_left_inlay} ${styles.orange}`} src={icon_collect_follow_evalution} alt="" />
                    <div className={styles.outer}>
                        <div className={styles.inner}>
                            <div className={`${styles.title} ${styles.orange_title}`}>{'治疗效果评估&生存随访'}</div>
                            <div className={`${styles.desc} ${styles.orange_desc}`}>
                                <img src={icon_collect_wait} alt="" />
                                <span>待处理质疑</span>
                            </div>
                        </div>
                    </div>
                    <div className={styles.arrow}>
                        <img src={icon_collect_arrow_orange} alt="" />
                    </div>
                </div>

                <div className={`${styles.outer_wrap} ${styles.bg_green}`}>
                    <img className={`${styles.img_left_inlay} ${styles.green}`} src={icon_collect_record} alt="" />
                    <div className={styles.outer}>
                        <div className={styles.inner}>
                            <div className={`${styles.title} ${styles.green_title}`}>用药信息</div>
                            <div className={`${styles.desc} ${styles.green_desc}`}>
                                <img src={icon_collect_ing} alt="" />
                                <span>进行中</span>
                            </div>
                        </div>
                    </div>
                    <div className={styles.arrow}>
                        <img src={icon_collect_arrow_green} alt="" />
                    </div>
                </div>

                <div className={`${styles.outer_wrap} ${styles.bg_blue}`}>
                    <img className={`${styles.img_left_inlay} ${styles.blue}`} src={icon_collect_quesionnaire} alt="" />
                    <div className={styles.outer}>
                        <div className={styles.inner}>
                            <div className={`${styles.title} ${styles.blue_title}`}>诊断信息</div>
                            <div className={`${styles.desc} ${styles.blue_desc}`}>
                                <img src={icon_collect_ok} alt="" />
                                <span>已完成</span>
                            </div>
                        </div>
                    </div>
                    <div className={styles.arrow}>
                        <img src={icon_collect_arrow_blue} alt="" />
                    </div>
                </div> */}

            </div>

            {showAcitonBtns()}
        </div>
    )
}

export default CaseCollect;